export default {
    assignmentTypeNameFilter(assignmentFactory) {
        'ngInject';

        return assignmentFactory.getAssignmentTypeName;
    },
};
